
export default {
    name: "EligibilityBanner",
    props: {
        eligibilityUrl: {
            type: String,
            required: true
        }
    }
}
